import {Breakpoints, css, styled} from '@volkswagen-onehub/components-core';
import {ResultsView} from '../utils/results-view-context';

type ResultsProps = {
  hasIncentives?: boolean;
  view: ResultsView;
  model?: string;
};

type ListViewStylesProps = {
  hasIncentives?: boolean;
};

export const ListViewStyles = css<ListViewStylesProps>`
  @media (min-width: ${Breakpoints.b960}px) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 50px min-content 10px 1fr 10px 55px;
    grid-column-gap: ${(props) => props.theme.size.static250};
    grid-row-gap: 0;
    grid-template-areas: ${(props) =>
      !props.hasIncentives
        ? `"jelly         stock          like"
      "jelly          model          price"
      "jelly          topdivider     topdivider"
      "jelly          description    colours"
      "jelly          bottomdivider  bottomdivider"
      "jelly          dealer         actions"`
        : `"jelly        stock          like"
      "jelly        model          price"
      "jelly        topdivider     topdivider"
      "jelly        description    colours"
      "incentives   bottomdivider  bottomdivider"
      "incentives   dealer         actions"`};

    padding-right: ${(props) => props.theme.size.dynamic0040};
  }
`;

export const StyledCard = styled.div<ResultsProps>`
  border: 1px solid rgb(223, 228, 232);
  border-radius: 8px;
  :focus-within {
    border: 1px solid #0077cc;
  }
  display: grid;
  grid-template-columns: ${(props) => props.theme.size.dynamic0050} 1fr 1fr ${(
      props,
    ) => props.theme.size.dynamic0050};
  grid-template-rows: 300px 40px auto 10px auto 1fr 10px min-content 40px min-content;
  grid-row-gap: ${(props) => props.theme.size.static100};
  padding-right: 0;
  grid-template-areas:
    'jelly         jelly               jelly           jelly'
    '.              stock               like            .'
    '.              model               price           .'
    '.              topdivider          topdivider      .'
    '.              colours             colours         .'
    '.              description         description     .'
    '.              bottomdivider       bottomdivider   .'
    '.              dealer              dealer          .'
    'incentives     incentives          incentives      incentives'
    'actions        actions             actions         actions';

  ${(props) => (props.view === ResultsView.LIST ? ListViewStyles : undefined)}
`;
